import { AuthProvider } from '@choco-admin/auth';
import { HeroUIProvider } from '@heroui/react';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { EnvironmentSelector } from './components/EnvironmentSelector';
import ErrorBoundary from './components/ErrorBoundary';
import {
  EnvironmentProvider,
  useEnvironment,
} from './contexts/EnvironmentContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { PuppyModeProvider } from './contexts/PuppyModeContext';
import { Routes } from './Routes';

// Inner App component that has access to environment context
function AppContent() {
  const { currentEnvironment, switchEnvironment, isLoading } = useEnvironment();

  return (
    <ErrorBoundary>
      <Routes />
      {/* Environment selector - shows on all pages except production */}
      <EnvironmentSelector
        currentEnvironment={currentEnvironment}
        onEnvironmentChange={switchEnvironment}
        disabled={isLoading}
      />
    </ErrorBoundary>
  );
}

function App() {
  return (
    <HelmetProvider>
      <HeroUIProvider>
        <ToastContainer limit={3} closeOnClick />
        <EnvironmentProvider>
          <PuppyModeProvider>
            <AuthProvider>
              <NotificationProvider>
                <AppContent />
              </NotificationProvider>
            </AuthProvider>
          </PuppyModeProvider>
        </EnvironmentProvider>
      </HeroUIProvider>
    </HelmetProvider>
  );
}

export default App;
